import { ClassProvider, Injectable } from '@angular/core';
import { NgbInputDatepickerConfig } from '@ng-bootstrap/ng-bootstrap';
import moment from 'moment-mini';

@Injectable()
export class CmInputDatepickerConfig extends NgbInputDatepickerConfig {
  constructor() {
    super();
  }

  override maxDate = {
    day: moment().get('date'),
    month: moment().get('month') + 1,
    year: moment().get('year') + 100,
  };

  override minDate = {
    day: moment().get('date'),
    month: moment().get('month') + 1,
    year: moment().get('year') - 100,
  };
}
export const NGB_DATEPICKER_INPUT_CONFIG: ClassProvider = {
  provide: NgbInputDatepickerConfig,
  useClass: CmInputDatepickerConfig,
};
